import { useState, useEffect } from 'react';

const BASE_URL = 'https://fraeternity.myshopify.com';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [inspoOpen, setInspoOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      
      // Determinar si estamos en la parte superior (para mostrar la barra roja)
      setIsScrolled(scrollTop > 50);
      
      // Lógica para mostrar/ocultar el header basado en dirección del scroll
      if (scrollTop < 50) {
        // Si estamos muy cerca del top, siempre mostrar el header
        setIsHeaderVisible(true);
      } else if (scrollTop > lastScrollY && scrollTop > 50) {
        // Scrolling hacia abajo inmediatamente después de pasar 50px
        setIsHeaderVisible(false);
      } else if (scrollTop < lastScrollY) {
        // Scrolling hacia arriba
        setIsHeaderVisible(true);
      }
      
      setLastScrollY(scrollTop);
    };

    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      {/* BARRA SUPERIOR - Marquee animado - Se esconde al hacer scroll */}
      <div className={`fixed top-0 w-full h-[45px] z-[9998] overflow-hidden bg-[#FF0000] flex items-center transition-transform duration-300 ${!isHeaderVisible ? '-translate-y-full' : 'translate-y-0'}`}>
        <div className="marquee-wrapper">
          <div className="marquee">
            <div className="marquee-content">
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
            </div>
            <div className="marquee-content">
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">BEST HOODIES IN TOWN</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
              <span className="marquee-text">ENVÍOS A TODA EUROPA</span>
              <img src="https://cdn.shopify.com/s/files/1/0622/4658/4507/files/Captura_de_pantalla_2025-02-02_a_las_18.30.28.png?v=1738521050" alt="Logo" className="marquee-logo" />
            </div>
          </div>
        </div>
              </div>

      {/* HEADER PRINCIPAL */}
      <header className={`header sticky bg-white shadow-sm border-b border-gray-200 transition-all duration-300 ${!isHeaderVisible ? '-translate-y-[calc(100%+45px)]' : isScrolled ? 'top-0' : 'top-[45px]'}`}>
        <div className="header__container">
          
          {/* LOGO CENTRAL */}
          <h1 className="header__logo">
            <a href={BASE_URL}>
              <span className="sr-only">FRAETERNITY</span>
              <img 
                src="https://fraeternity.myshopify.com/cdn/shop/files/LOGO_FTTY_1.png?v=1737489768&width=570"
                alt="FRAETERNITY" 
                srcSet="https://fraeternity.myshopify.com/cdn/shop/files/LOGO_FTTY_1.png?v=1737489768&width=380 380w, https://fraeternity.myshopify.com/cdn/shop/files/LOGO_FTTY_1.png?v=1737489768&width=570 570w"
                width="570"
                height="auto"
                sizes="(max-width: 1024px) 150px, (max-width: 700px) 180px, 200px"
                className="header__logo-image"
                />
              </a>
          </h1>

          {/* Botón hamburguesa móvil */}
          <button 
            type="button" 
            aria-controls="sidebar-menu" 
            className="header__nav-toggle lg:hidden"
            onClick={toggleMenu}
          >
            <span className="sr-only">Menú</span>
            <svg 
              aria-hidden="true" 
              fill="none" 
              focusable="false" 
              width="24" 
              className="header__nav-icon icon icon-hamburger" 
              viewBox="0 0 24 24"
            >
              <path d="M1 19h22M1 12h22M1 5h22" stroke="currentColor" strokeWidth="1" strokeLinecap="square"></path>
            </svg>
          </button>

          {/* NAVEGACIÓN PRINCIPAL (Desktop) */}
          <nav className="header__primary-nav header__primary-nav--center" aria-label="Navegación principal">
            
            {/* Navegación desktop */}
            <ul className="header__nav-list contents unstyled-list">
              
              <li className="header__primary-nav-item" data-title="INSPO">
                <div 
                  className="header__menu-disclosure-wrapper"
                  onMouseEnter={() => setInspoOpen(true)}
                  onMouseLeave={() => setInspoOpen(false)}
                >
                  <button 
                    className="header__menu-button h6"
                  >
                    INSPO
                  </button>
                  
                  {/* Dropdown INSPO */}
                  {inspoOpen && (
                    <ul 
                      className="header__dropdown-menu unstyled-list"
                      role="list"
                    >
                      <li><a href={`${BASE_URL}/collections/colegios`} className="link-faded-reverse">COLEGIOS</a></li>
                      <li><a href={`${BASE_URL}/collections/viajes`} className="link-faded-reverse">VIAJES</a></li>
                      <li><a href={`${BASE_URL}/collections/cmus`} className="link-faded-reverse">CMU's / RESIS</a></li>
                      <li><a href={`${BASE_URL}/collections/erasmus`} className="link-faded-reverse">ERASMUS</a></li>
                      <li><a href={`${BASE_URL}/collections/quintos`} className="link-faded-reverse">QUINTOS</a></li>
                    </ul>
                  )}
                </div>
              </li>

              <li className="header__primary-nav-item" data-title="COLOR & SIZE">
                <a href={`${BASE_URL}/pages/colors-sizes`} className="block h6">COLOR & SIZE</a>
              </li>

              <li className="header__primary-nav-item" data-title="BANK">
                <a href={BASE_URL} className="block h6" aria-current="page">BANK</a>
              </li>

              <li className="header__primary-nav-item" data-title="TIKTOK REWARDS">
                <a href={`${BASE_URL}/pages/tiktok-rewards`} className="block h6">TIKTOK REWARDS</a>
              </li>

              <li className="header__primary-nav-item" data-title="FTTY DROPS">
                <a href={`${BASE_URL}/pages/fraeternity-drops`} className="block h6">FTTY DROPS</a>
              </li>

              <li className="header__primary-nav-item" data-title="AREA CLIENTE">
                <a href={BASE_URL} className="block h6" aria-current="page">AREA CLIENTE</a>
              </li>

              <li className="header__primary-nav-item" data-title="ABOUT FTTY">
                <a href={`${BASE_URL}/pages/about-fraeternity`} className="block h6">ABOUT FTTY</a>
              </li>

            </ul>
          </nav>

          {/* NAVEGACIÓN SECUNDARIA */}
          <nav className="header__secondary-nav" aria-label="Navegación secundaria">
            <ul className="contents unstyled-list">
              {/* Espacio para navegación secundaria si se necesita */}
            </ul>
          </nav>

        </div>
      </header>

      {/* SIDEBAR MÓVIL */}
      {menuOpen && (
        <>
          {/* Overlay */}
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-[9998] lg:hidden"
            onClick={toggleMenu}
          ></div>
          
          {/* Sidebar */}
          <div className="header-sidebar drawer drawer--sm fixed top-0 left-0 h-full w-80 bg-[#FF0000] shadow-xl z-[9999] transform transition-transform duration-300 lg:hidden translate-x-0">
            <div className="header-sidebar__main-panel">
              <div className="header-sidebar__scroller p-6">
                
                {/* Header del sidebar */}
                <div className="flex items-center justify-end mb-8">
                  <button 
                    onClick={toggleMenu}
                    className="p-2 hover:bg-red-600 rounded-md text-white"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <ul className="header-sidebar__linklist unstyled-list space-y-2" role="list">
                  
                  <li>
                    <button 
                      type="button" 
                      className="header-sidebar__linklist-button h6 text-white w-full text-left flex items-center justify-between py-3"
                      onClick={() => setInspoOpen(!inspoOpen)}
                    >
                      INSPO
                      <svg 
                        className={`w-4 h-4 transform transition-transform ${inspoOpen ? 'rotate-180' : ''}`} 
                        fill="currentColor" 
                        viewBox="0 0 10 10"
                      >
                        <path d="m3 9 4-4-4-4" stroke="currentColor" strokeLinecap="square"></path>
                      </svg>
                    </button>
                    {inspoOpen && (
                      <div className="ml-4 mt-2 space-y-2">
                        <a href={`${BASE_URL}/collections/colegios`} className="header-sidebar__linklist-button text-white/80 block py-2">COLEGIOS</a>
                        <a href={`${BASE_URL}/collections/viajes`} className="header-sidebar__linklist-button text-white/80 block py-2">VIAJES</a>
                        <a href={`${BASE_URL}/collections/cmus`} className="header-sidebar__linklist-button text-white/80 block py-2">CMU's / RESIS</a>
                        <a href={`${BASE_URL}/collections/erasmus`} className="header-sidebar__linklist-button text-white/80 block py-2">ERASMUS</a>
                        <a href={`${BASE_URL}/collections/quintos`} className="header-sidebar__linklist-button text-white/80 block py-2">QUINTOS</a>
                      </div>
                    )}
                  </li>
                  
                  <li><a href={`${BASE_URL}/pages/colors-sizes`} className="header-sidebar__linklist-button h6 text-white block py-3">COLOR & SIZE</a></li>
                  <li><a href={BASE_URL} className="header-sidebar__linklist-button h6 text-white block py-3">BANK</a></li>
                  <li><a href={`${BASE_URL}/pages/tiktok-rewards`} className="header-sidebar__linklist-button h6 text-white block py-3">TIKTOK REWARDS</a></li>
                  <li><a href={`${BASE_URL}/pages/fraeternity-drops`} className="header-sidebar__linklist-button h6 text-white block py-3">FTTY DROPS</a></li>
                  <li><a href={BASE_URL} className="header-sidebar__linklist-button h6 text-white block py-3">AREA CLIENTE</a></li>
                  <li><a href={`${BASE_URL}/pages/about-fraeternity`} className="header-sidebar__linklist-button h6 text-white block py-3">ABOUT FTTY</a></li>
                  
                </ul>
              </div>
            </div>
        </div>
        </>
      )}

      {/* CSS del Header de Fraeternity */}
      <style>{`
        /* Variables CSS del Header */
        :root {
          --header-grid-mobile: "nav-toggle logo secondary-nav" / auto 1fr auto;
          --header-grid-desktop: "nav-toggle logo secondary-nav" "nav nav nav" / auto 1fr auto;
          --header-logo-width: 150px;
          --text-color: #FF0000;
          --background: #FFFFFF;
        }

        @media screen and (min-width: 700px) {
          :root {
            --header-logo-width: 180px;
          }
        }

        @media screen and (min-width: 1024px) {
          :root {
            --header-logo-width: 200px;
          }
        }

        @media screen and (min-width: 1024px) {
          :root {
            --header-grid: ". logo ." "primary-nav primary-nav primary-nav" / 1fr auto 1fr;
          }
        }

        /* Header principal */
        .header {
          z-index: 9997;
          background: var(--background);
          height: 100px; /* Altura exacta móvil */
        }
        
        @media screen and (min-width: 1024px) {
          .header {
            height: 140px; /* Altura exacta desktop */
          }
        }

        .header__container {
          display: grid;
          grid-template: var(--header-grid-mobile);
          align-items: center; /* Centrar elementos verticalmente en móvil */
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px 1rem;
          height: 100px; /* Altura exacta móvil */
          box-sizing: border-box;
        }

        @media screen and (min-width: 1024px) {
          .header__container {
            grid-template: var(--header-grid-desktop);
            grid-template-rows: 2fr 1fr; /* Logo ocupa 2/3, navegación 1/3 */
            align-items: stretch; /* En desktop, usar el grid de filas */
            padding: 20px 2rem;
            height: 140px; /* Altura exacta desktop */
          }
        }

        /* Logo */
        .header__logo {
          grid-area: logo;
          justify-self: center;
          margin: 0;
          align-self: center;
          padding: 0.5rem 0; /* Reducido para móvil */
        }
        
        @media screen and (min-width: 1024px) {
          .header__logo {
            padding: 0.75rem 0; /* Reducido para desktop */
          }
        }

        .header__logo a {
          text-decoration: none; /* Sin subrayado en el enlace del logo */
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header__logo-image {
          width: var(--header-logo-width);
          height: auto;
          display: block;
        }

        /* Navegación principal */
        .header__primary-nav {
          grid-area: primary-nav;
          justify-self: center; /* Centrado horizontalmente */
          align-self: center; /* Centrado verticalmente */
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        @media screen and (min-width: 1024px) {
          .header__primary-nav {
            display: flex !important; /* Mostrar navegación en desktop */
            grid-area: nav; /* En desktop usa el área 'nav' de la segunda fila */
            grid-column: 1 / -1; /* Ocupa todo el ancho */
          }
        }

        .header__primary-nav--center {
          justify-self: center;
        }

        @media screen and (min-width: 1024px) {
          .header__primary-nav--center {
            justify-self: stretch;
            text-align: center;
          }
        }

        .header__nav-list {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2.5rem;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        @media (max-width: 1023px) {
          .header__nav-list {
            display: none;
          }
          
          .header__primary-nav {
            display: none; /* Ocultar navegación en móvil */
          }
        }

        .header__primary-nav-item {
          position: relative;
        }

        .header__menu-disclosure-wrapper {
          position: relative;
        }

        .header__menu-button,
        .header__primary-nav-item .h6,
        .header__primary-nav-item a {
          font-family: Helvetica, 'Helvetica Neue', Arial, 'Lucida Grande', sans-serif;
          font-weight: 700;
          font-style: oblique;
          text-transform: uppercase;
          letter-spacing: -0.05em;
          color: #FF0000;
          text-decoration: none;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.5rem 0;
          transition: all 0.2s ease;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .header__menu-button::after,
        .header__primary-nav-item .h6::after,
        .header__primary-nav-item a::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -20px; /* Posición en el borde inferior del header */
          height: 3px; /* Misma altura que tenía la banda */
          background-color: #FF0000;
          transform: scaleX(0);
          transform-origin: center;
          transition: transform 0.2s ease;
        }

        .header__menu-button:hover::after,
        .header__primary-nav-item .h6:hover::after,
        .header__primary-nav-item a:hover::after {
          transform: scaleX(1);
        }

        /* Dropdown menu */
        .header__dropdown-menu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: white;
          border: 2px solid #FF0000;
          border-radius: 8px;
          box-shadow: 0 8px 32px rgba(255, 0, 0, 0.15);
          padding: 0.75rem 0;
          min-width: 220px;
          z-index: 9999;
          margin-top: 0.25rem;
          animation: dropdownFadeIn 0.2s ease-out;
        }
        
        @keyframes dropdownFadeIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        .header__dropdown-menu li {
          list-style: none;
        }

        .link-faded-reverse {
          font-family: Helvetica, 'Helvetica Neue', Arial, sans-serif;
          font-weight: 400;
          text-transform: uppercase;
          color: #333;
          text-decoration: none;
          display: block;
          padding: 0.75rem 1.5rem;
          transition: all 0.3s ease;
          border-left: 3px solid transparent;
        }

        .link-faded-reverse:hover {
          background-color: #FFF5F5;
          color: #FF0000;
          border-left-color: #FF0000;
          font-weight: 500;
        }

        /* Botón hamburguesa */
        .header__nav-toggle {
          background: none;
          border: none;
          padding: 0.5rem;
          cursor: pointer;
          grid-area: nav-toggle;
          justify-self: start;
          align-self: center;
          z-index: 9996;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media screen and (min-width: 1024px) {
          .header__nav-toggle {
            display: none;
          }
        }

        .header__nav-icon {
          stroke: #000;
        }

        /* Navegación secundaria */
        .header__secondary-nav {
          grid-area: secondary-nav;
          justify-self: end;
          align-self: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Marquee styles */
        .marquee-wrapper {
          width: 100%;
          overflow: hidden;
          background-color: #FF0000;
          color: #fff;
          padding: 12px 0;
          position: relative;
          white-space: nowrap;
          height: 45px;
          display: flex;
          align-items: center;
        }

        .marquee {
          display: flex;
          width: max-content;
          animation: marquee-scroll 60s linear infinite;
        }

        .marquee-content {
          display: flex;
          align-items: center;
          gap: 40px;
          flex-shrink: 0;
          min-width: 100vw;
          justify-content: center;
        }

        .marquee-text {
          font-family: Helvetica, 'Helvetica Neue', Arial, sans-serif;
          font-weight: 700;
          font-size: 12px;
          text-transform: uppercase;
          color: #fff;
        }

        .marquee-logo {
          height: 25px;
          width: auto;
          display: inline-block;
        }

        @keyframes marquee-scroll {
          from {
            transform: translateX(0%);
          }
          to {
            transform: translateX(-100%);
          }
        }

        /* Sidebar móvil */
        .header-sidebar__linklist-button {
          font-family: Helvetica, 'Helvetica Neue', Arial, sans-serif;
          font-weight: 400;
          text-transform: uppercase;
          text-decoration: none;
          transition: all 0.2s ease;
        }

        .header-sidebar__linklist-button.h6 {
          font-weight: 700;
          font-style: oblique;
        }

        .header-sidebar__linklist-button:hover {
          opacity: 0.8;
        }

        /* Utilidades */
        .contents {
          display: contents;
        }

        .unstyled-list {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .h6 {
          font-size: 1rem;
          line-height: 1.4;
          margin: 0;
        }

        .block {
          display: block;
        }

        /* Responsive */
        @media (max-width: 1023px) {
          .header__nav-toggle {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .header__nav-list {
            display: none;
          }
        }

        @media (min-width: 1024px) {
          .header__nav-toggle {
            display: none !important;
          }
          
          .header__primary-nav {
            display: block;
          }
          
          .header__nav-list {
            display: flex;
          }
          
          .lg\\:hidden {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
} 